export const SEND_API =  "https://fazoacademy.in/php/sendmail.php";